import { useEffect, useState } from 'react';
import {
  supabase,
  signInAnonymously as anonymousSignIn,
  signInWithGoogle as googleSignIn,
  signInWithGitHub as githubSignIn,
  signInWithMagicLink as magicLinkSignIn,
  signInWithPhone as phoneSignIn,
  verifyOtp as verifyOtpCode,
  resetPassword as resetPasswordEmail,
} from '../lib/supabase';
import { useStore } from '../store';

export const useAuth = () => {
  const { user, setUser } = useStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setIsLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, [setUser]);

  const signIn = async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    return { data, error };
  };

  const signUp = async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signUp({ email, password });
    return { data, error };
  };

  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    return { error };
  };

  const signInWithGoogle = async () => googleSignIn();
  const signInAnonymous = async () => anonymousSignIn();
  const signInWithGitHub = async () => githubSignIn();
  const signInWithMagicLink = async (email: string) => magicLinkSignIn(email);
  const signInWithPhone = async (phone: string) => phoneSignIn(phone);
  const verifyOtp = async (phone: string, token: string) => verifyOtpCode(phone, token);
  const resetPassword = async (email: string) => resetPasswordEmail(email);

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    signIn,
    signUp,
    signOut,
    signInWithGoogle,
    signInAnonymous,
    signInWithGitHub,
    signInWithMagicLink,
    signInWithPhone,
    verifyOtp,
    resetPassword,
  };
};
